import { render, staticRenderFns } from "./SmsContentEditor.vue?vue&type=template&id=24d05e1c&scoped=true"
import script from "./SmsContentEditor.vue?vue&type=script&lang=js"
export * from "./SmsContentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d05e1c",
  null
  
)

export default component.exports